const updates = [
  { time: '5分钟前', title: '某女星深夜发文疑似回应出轨传闻', badge: '最新' },
  { time: '28分钟前', title: '热门网剧被指抄袭海外作品，编剧回应', badge: '热议' },
  { time: '1小时前', title: '知名歌手演唱会突发设备故障，现场观众齐声合唱', badge: '暖' },
  { time: '2小时前', title: '某综艺节目录制路透曝光，飞行嘉宾引猜测', badge: '独家' },
  { time: '3小时前', title: '品牌官宣新代言人，评论区瞬间沦陷', badge: '爆' },
  { time: '5小时前', title: '网红带货产品被曝质量问题，市监局介入调查', badge: '追踪' },
  { time: '8小时前', title: '跨年晚会彩排花絮流出，舞美效果惊艳', badge: '热' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">最新快讯</h2>
          <span className="text-xs text-foreground-400">实时滚动更新</span>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>
          <div className="space-y-5">
            {updates.map((item) => (
              <a
                key={item.title}
                href="#updates"
                className="group flex items-start gap-5 cursor-pointer"
              >
                <div className="relative z-10 w-[38px] h-[38px] rounded-full bg-background-50 border-2 border-accent-200 flex items-center justify-center flex-shrink-0 group-hover:border-accent-400 transition-colors">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                </div>
                <div className="flex-1 min-w-0 pt-1.5">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-[10px] font-bold text-primary-600 bg-primary-100 px-1.5 py-0.5 rounded whitespace-nowrap">{item.badge}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors mt-1">
                    {item.title}
                  </h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}